import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PostService {

  baseApiUrl = environment.baseApiUrl;
  posts: any[] = [];

  constructor(private http: HttpClient) { }

  getSocialActivityPosts(page: number = 1, limit: number = 10): Observable<any> {
    return this.http.get<any>(`${this.baseApiUrl}/posts/social-activity?page=${page}&limit=${limit}`);
  }

  getCharityWorkPosts(page: number = 1, limit: number = 10): Observable<any> {
    return this.http.get<any>(`${this.baseApiUrl}/posts/charity-work?page=${page}&limit=${limit}`);
  }

  getPostById(id: number): Observable<any> {
    return this.http.get(`${this.baseApiUrl}/posts/${id}`);
  }  

  getPosts(page: number = 1, limit: number = 10): Observable<any> {
    return this.http.get<any>(`${this.baseApiUrl}/posts?page=${page}&limit=${limit}`);
  }

}
